import Headline from "./atoms/headline"
import { InstagramIcon } from "./atoms/contactIcons"

const News = () => {
    return (
        <div id='news' className='section'>
            <Headline
                title={'News'}
                subTitle={'ニュース'}
            />
            <a
                className="instagram-link"
                href="https://www.instagram.com/liina_dancestudio"
                target="_blank"
                rel="noopener noreferrer"
            >
                <InstagramIcon />
                @liina_dancestudio
            </a>
        </div>
    )
}

export default News
